<h1 class="text-center !text-3xl !font-normal text-tertiary-900">
    Confirm your request
</h1>
<h2 class="text-center !text-base !font-medium text-tertiary-900">
    Upon confirmation below, your technical data will be submitted to Cevo Go,
    and will be summarized by email to you.
</h2>

<div class="flex flex-col space-y-4">
    <app-go-application-purpose-selection
        [applicationPurpose]="
            goApplicationRequestForm.controls.applicationPurpose.value
        "
        [fccRegistrationNumber]="
            goApplicationRequestForm.controls.fccRegistrationNumber.value
        "
        [callSign]="goApplicationRequestForm.controls.callSign.value"
    ></app-go-application-purpose-selection>

    <app-go-parameters-summary
        [form]="goApplicationRequestForm"
        [hideToggle]="true"
        [disabled]="true"
    ></app-go-parameters-summary>
</div>
